import React, { ReactNode, useContext } from "react";
import { Badge, Collapse } from "reactstrap";
import { AppContext } from "../../context/app";

type SidebarCategoryProps = {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  name: string;
  path: string;
  header?: boolean;
  badgeText?: string;
  badgeColor?: string;
  onClick: () => void;
  isOpen: boolean;
  children: ReactNode;
};

const SidebarCategory = ({
  name,
  badgeColor = "#FFF",
  badgeText,
  icon: Icon,
  isOpen,
  children,
  onClick,
  path: to,
}: SidebarCategoryProps) => {
  const { spa } = useContext(AppContext);
  const getSidebarItemClass = (path) => {
    return window.location.pathname.indexOf(path) !== -1 ||
      (window.location.pathname === "/" && path === "/dashboard")
      ? "active"
      : "";
  };

  return (
    <li className={`sidebar-item ${getSidebarItemClass(to)}`}>
      <span
        role="button"
        tabIndex={0}
        data-toggle="collapse"
        className={`sidebar-link ${!isOpen ? "collapsed" : ""}`}
        onClick={onClick}
        aria-expanded={isOpen ? "true" : "false"}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onClick();
          }
        }}
      >
        <Icon
          className="align-middle mr-2"
          color="white"
          style={{
            width: "18px",
            height: "18px",
          }}
        />
        {spa ? <span className="align-middle">{name}</span> : name}
        {badgeColor && badgeText ? (
          <Badge color={badgeColor} size={18} className="sidebar-badge">
            {badgeText}
          </Badge>
        ) : null}
      </span>
      <Collapse isOpen={isOpen}>
        <ul id="item" className="sidebar-dropdown list-unstyled">
          {children}
        </ul>
      </Collapse>
    </li>
  );
};

export default SidebarCategory;
